import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Starts an auto-dismiss timer for toasts that have finite durations.
 */
export const autoDismiss = store.effects.create((feature: Feature) =>
  feature.actions.show.observe().pipe(
    rxjs.mergeMap(action =>
      rxjs.from(action.data.toasts).pipe(
        rxjs.mergeMap(toast => {
          if (toast.durationMs === null) {
            return rxjs.EMPTY
          }

          return rxjs.timer(toast.durationMs).pipe(
            rxjs.takeUntil(
              rxjs.merge(
                feature.actions.dismiss
                  .observe()
                  .pipe(
                    rxjs.filter(
                      dismissAction => dismissAction.data.id === toast.id,
                    ),
                  ),
                feature.actions.dismissAll.observe(),
              ),
            ),
            rxjs.map(() =>
              feature.actions.autoDismissExpired.from(action).create({
                id: toast.id,
              }),
            ),
          )
        }),
      ),
    ),
  ),
)
